import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import { fetchFiliales, fetchFamilia,  loadMantenimiento } from '../../actions';
import PageHeader from '../../components/PageHeader';
import Alert from '../../components/Alert';
import Paginacion from '../../components/Paginacion';
import Filtros from './Filtros';
import TablaMantenimiento from './TablaMantenimiento';
import Formulario from './Formulario';
import FromRegistro from './FromRegistro';
import toggleDiv from '../../utils/toggleDiv';
import { createCertificado, getListarAreas,getListaAreaVenta,getListarCertificado,createArea } from '../../utils/mantenimientoFichaVenta';

class MantAreadeVenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idCertificado: '',
      familia: '',
      alertErrorOpen: false,
      alertSuccessOpen: false,
      // Paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      // modal
      modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
      filialFormulario: '',
      inddefault:false,
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      flota: false,
      buscar:'',
      listaAreaVenta:[],
      listaCertificado:[],
      listaAreaAll:[],
      descripcion:'',
      valueActive:false,
      valueEdit:false,
    
    };
  }

  componentDidMount() {
    document.addEventListener('click', toggleDiv, true);

    
    getListarCertificado('').then((resultado)=>{
      this.setState({listaCertificado:resultado.data.lstAreaVenta
        
      });
    });

    this.props.fetchFiliales();
    this.props.fetchFamilia();


  }

  componentWillUnmount() {
    document.removeEventListener('click', toggleDiv, true);
  }

  onChangeGroup = (e, group) => {
    const array = this.state[group];
    if (array.indexOf(e.target.value)>=0) {
      this.setState({ [group]: array.filter(item => item !== e.target.value) });
    } else {
      this.setState({ [group]: [...array, e.target.value] });
    }
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value });
  onChangeChecked = () =>{
    
    console.log('this.state.valueActive',!this.state.valueActive);

    this.setState({
      valueActive: !this.state.valueActive
    });
  } 
  onCheck = e => this.setState({ [e.target.name]: e.target.checked });

  onChangeAndFilter = (e) => {
    this.setState(
      { [e.target.name]: e.target.value }
    );
  }

  searchCertificado = () =>{
    getListarCertificado(this.state.buscar).then((resultado)=>{
      this.setState({listaCertificado:resultado.data.lstAreaVenta        
      });
    })

  }

  openModalWithValues = (modal, mantenimiento) => {
    getListarAreas().then((result) =>{
      this.setState({listaAreaAll:result.data.lstAreaVenta},
      ()=>{
        getListaAreaVenta(mantenimiento.cod_chek).then((result)=>{
          this.setState({listaAreaVenta:result.data.lstAreaVenta},()=>{
            let areas = [...this.state.listaAreaAll];
            this.state.listaAreaVenta.forEach(element => {          
              let index = areas.findIndex(el => el.cod_area_vta === element.cod_area_vta);
              areas[index] = {...areas[index],ind_default:element.ind_default};
              areas[index] = {...areas[index],ind_inactivo:element.ind_inactivo};          
            });
            this.setState({listaAreaAll:areas,
              modalOpen: modal,    
            registroSelected: mantenimiento,
            descripcion:mantenimiento.des_chek,
            valueActive:mantenimiento.ind_inactivo === 'N'?true:false,
            modalTitle: 'Editar registro',});
          }
          );
        });
      });
    });
  }

  onChangeInactivo = (cod,value) =>{  
    let areas = [...this.state.listaAreaAll];
    let index = areas.findIndex(el => el.cod_area_vta === cod);
    areas[index] = {...areas[index],ind_inactivo:value === 'N'?'S':'N'};
    this.setState({listaAreaAll:areas});  
  }

  onChangeDefault = (cod,value) => {
    let areas = [...this.state.listaAreaAll];
    let index = areas.findIndex(el => el.cod_area_vta === cod);
    areas[index] = {...areas[index],ind_default:value === 'N'?'S':'N'};    
    this.setState({listaAreaAll:areas});
  }

  createRegistro = () => {
    this.state.listaAreaAll.forEach((entity)=>{
      if(entity.ind_default !== null || entity.ind_inactivo !== null){
        createCertificado(entity,this.state.registroSelected.cod_chek).then((response)=>{
            if(response.data.estadoTrama === '1'){
              this.setState({alertSuccessOpen:true});
            }
        });
      }
    });
  

    this.resetForm();
  }

 

  closeAlertError = () => this.setState({ alertErrorOpen: false });
  closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });
  editBtn = () => {
    this.setState({valueEdit:!this.state.valueEdit});
  
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }


  reset = () => {
    this.setState({
      idCertificado: '',
      familia: '',
      descripcion:'',
    });
  
  }

  resetForm = () => {
    this.setState({
      modalOpen: '',
      modalTitle: 'Crear registro',
      areaFormulario:'',
      certificadoFormulario:'',
      indInactivo: false,
      inddefault:false,
      disabledSelects: false,
      registroSelected: '',
      descripcion:'',
      valueEdit:false,
    });
  }

  closeModal = () => this.setState({ modalOpen: '' });
  openModal = modal => this.setState({ modalOpen: modal });

  createAreaBtn = () =>{
    createArea('','',this.state.descripcion).then((response)=>{
    
      if(response.data.estadoTrama === '1'){
        this.setState({alertSuccessOpen:true});
      }
      this.resetForm();
      getListarCertificado('').then((resultado)=>{
        this.setState({listaCertificado:resultado.data.lstAreaVenta
          
        });
      });

    });
  }


  createAreaBtnGuardar = (cod_chek) =>{
    createArea(cod_chek,this.state.valueActive,this.state.descripcion).then((response)=>{
    
      if(response.data.estadoTrama === '1'){
        this.setState({alertSuccessOpen:true});
      }
      this.resetForm();
      getListarCertificado('').then((resultado)=>{
        this.setState({listaCertificado:resultado.data.lstAreaVenta
          
        });
      });

    });
  }

  render() {
    const { mantenimientoEntrega, filiales, familias } = this.props;

    return (
      <div>
        <PageHeader title='Mantenimiento de  certificados por area de venta'  buttonName='Nuevo registro' modalName='FromRegistro' openModal={this.openModal} />
        <Filtros        
          listaCertificado={this.state.listaCertificado}
          buscar = {this.state.buscar}
          onChangeAndFilter={this.onChangeAndFilter}
          searchCertificado ={this.searchCertificado}

        />
      
        <div className='wrapper'>
          <div className='tableWrapper'>
            <table className='table table-hover' style={{ marginBottom: '20px' }} >
              <thead className='table-head'>
                <tr>
                  <th>Cod. </th>
                  <th>Descripción de certificado</th>                  
                  <th>Usuario</th>
                  <th>Fecha de registro</th>   
                  <th>IND. DE INACTIVIDAD</th>
                  <th />
                </tr>
              </thead>
              {
                
                this.state.listaCertificado ?
                  <TablaMantenimiento
                    listaCertificado={this.state.listaCertificado}
                    openModal={this.openModalWithValues}
                  /> :
                  <tbody>
                    <tr>
                      <td colSpan={15}><FadeLoader color={'#F8A14A'} loading /></td>
                    </tr>
                  </tbody>
              }
            </table>
          </div>
        </div>
        <Formulario
          isOpen={this.state.modalOpen === 'mantenimiento'}
          title={this.state.modalTitle}
          closeModal={this.resetForm}
          onChangeValue={this.onChangeValue}
          create={this.createRegistro}
          registroSelected={this.state.registroSelected}
          onCheck={this.onCheck}         
          listaAreaAll={this.state.listaAreaAll}  
          onChangeInactivo ={this.onChangeInactivo}
          onChangeDefault = {this.onChangeDefault}
          descripcion = {this.state.descripcion} 
          valueEdit = {this.state.valueEdit}     
          createAreaBtnGuardar = {this.createAreaBtnGuardar}
          editBtn = {this.editBtn}
          onChangeChecked = {this.onChangeChecked}
          valueActive ={ this.state.valueActive}
        />

        <FromRegistro
         isOpen={this.state.modalOpen === 'FromRegistro'}
         title={'Crear Registro'}
         closeModal={this.resetForm}
         onChangeValue={this.onChangeValue}
         closeModal={this.resetForm}
         createAreaBtn = {this.createAreaBtn}
         descripcion = {this.state.descripcion}
        />

        {
          this.state.alertErrorOpen &&
            <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>Hubo un error al guardar el registro</p>
            </Alert>
        }
        {
          this.state.alertSuccessOpen &&
            <Alert type='alert-success' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess}>
              <p>Se guardó correctamente el registro</p>
            </Alert>
        }
        {
          (this.state.listaAreaVenta && this.state.listaAreaVenta.error) &&
            <Alert type='alert-danger' icon='ion-alert-circled'>
              <p>{this.state.listaAreaVenta.mensaje}</p>
            </Alert>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    filiales: state.filiales,
    familias: state.familias,
  };
}

MantAreadeVenta.defaultProps = {
  familias: [],
  filiales: [],
};

export default connect(
  mapStateToProps,
  { fetchFiliales, fetchFamilia,  loadMantenimiento }
)(MantAreadeVenta)



// WEBPACK FOOTER //
// ./src/pages/MantAreadeVenta/MantAreadeVenta.js